import React from "react";
import { Form, Uploader } from "rsuite";

const Documents = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Photo</Form.ControlLabel>
        <Form.Control name="photo" accepter={Uploader} action="#" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Citizenship Front</Form.ControlLabel>
        <Form.Control name="CitizenshipFront" accepter={Uploader} action="#" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Citizenship Back</Form.ControlLabel>
        <Form.Control name="CitizenshipBack" accepter={Uploader} action="#" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Passport</Form.ControlLabel>
        <Form.Control name="Passport" accepter={Uploader} action="#" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Provided Fund</Form.ControlLabel>
        <Form.Control name="ProvidedFund" accepter={Uploader} action="#" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Signature</Form.ControlLabel>
        <Form.Control name="Signature" accepter={Uploader} action="#" />
      </Form.Group>
    </div>
  );
};

export default Documents;
